export default __webpack_public_path__ + "static/media/Rp.cb1d1248.svg";